var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceRecorder" } }, [
    _c(
      "div",
      { staticClass: "trigger-button", on: { click: _vm.handleButtonClick } },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.isRecording && !_vm.isPreview
      ? _c(
          "div",
          { staticClass: "voice-record-phase" },
          [
            _c(
              "a-tooltip",
              { attrs: { title: "İptal Et" } },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "actionBtn",
                    attrs: { id: "cancelBtn" },
                    on: { click: _vm.cancelRecord },
                  },
                  [_c("md-icon", { staticClass: "icon" }, [_vm._v("close")])],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "frequence" },
              [
                _c("av-media", {
                  attrs: {
                    id: "av-media",
                    media: _vm.media,
                    type: "frequ",
                    canvWidth: 90,
                    canvHeight: 24,
                    lineColor: "white",
                    "frequ-lnum": 15,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "duration-display" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.formattedDuration) +
                  " / " +
                  _vm._s(_vm.formattedMaxDuration) +
                  "\n        "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isPreview
      ? _c(
          "div",
          { staticClass: "voice-preview-phase" },
          [
            _c(
              "a-tooltip",
              { attrs: { title: "Sil ve Vazgeç" } },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "actionBtn",
                    attrs: { id: "deleteBtn" },
                    on: { click: _vm.cancelPreview },
                  },
                  [
                    _c("md-icon", { staticClass: "icon" }, [
                      _vm._v("delete_outline"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "preview-player-container" },
              [
                _c(
                  "a-tooltip",
                  {
                    attrs: { title: _vm.previewPaused ? "Oynat" : "Duraklat" },
                  },
                  [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.togglePreviewAudio()
                          },
                        },
                      },
                      [
                        _c("md-icon", { attrs: { id: "playButton" } }, [
                          _vm._v(
                            _vm._s(_vm.previewPaused ? "play_arrow" : "pause")
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("av-waveform", {
                  ref: "waveformPreview",
                  attrs: {
                    id: "waveform-preview",
                    playtime: false,
                    playtimeWithMs: false,
                    playtimeTextBottom: false,
                    playtimeSliderWidth: 2,
                    noplayedLineColor: "#999999",
                    "played-line-color": "#4e8cff",
                    "audio-src": _vm.previewUrl,
                    playtimeFontSize: 0,
                    canvWidth: 140,
                    canvHeight: 30,
                    "played-line-width": 0.5,
                    "noplayed-line-width": 0.5,
                    "playtime-slider-color": "#4E8CFF",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "duration-display preview-duration" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.formattedDuration) + "\n        "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }